import { Rack } from "src/services/item/rack.interface";
import { ItemStatus, ItemCategory, ItemSeason } from "src/shared/backend-api.types";

export { ItemStatus, ItemCategory, ItemSeason };

export type DimensionUnit = "cm" | "in";
export type WeightUnit = "kg" | "lbs";

export interface ItemDimension {
  dimensionUnit: DimensionUnit;
  height: number;
  length: number;
  weight: number;
  weightUnit: WeightUnit;
  width: number;
}

export function isItemDimension(input: object): input is ItemDimension {
  return "height" in input && "length" in input && "weight" in input && "width" in input;
}

export interface Item extends Rack {
  areaId?: string;
  brand?: string;
  category: ItemCategory | null;
  color?: string;
  createdAt: any;
  description?: string;
  dimension?: ItemDimension;
  id: string;
  image?: string;
  insuredValue?: number;
  isFav?: boolean;
  name?: string;
  notes?: string[];
  numberId?: number;
  /** @deprecated */
  photo?: string;
  /** @deprecated */
  rack?: string;
  reclaimedAt?: string;
  seasons: ItemSeason[];
  size?: string;
  sport?: string;
  status: ItemStatus;
  userId: string;
  warehouse?: string;
  warehouseId?: string;
}

export const stillInClosetStatuses: ItemStatus[] = ["inStaging", "inStorage", "inTrip", "inVehicle", "onboarding"];

export type SelectableItem = Item & { selected?: boolean };

export function isSelectableItem(item: Item | SelectableItem): item is SelectableItem {
  return "item" in item && "selected" in item;
}

export function itemDimensionToString(itemDimension: ItemDimension): string {
  const hasNoSize = !itemDimension.height && !itemDimension.length && !itemDimension.width;
  const hasNoWeight = !itemDimension.weight;
  const hasNoDimension = hasNoSize && hasNoWeight;

  if (hasNoDimension) {
    return "No dimension";
  }

  const sizeString = hasNoSize
    ? "No size data"
    : `${itemDimension.height ?? "?"} x ${itemDimension.length ?? "?"} x ${itemDimension.width ?? "?"} ${
        itemDimension.dimensionUnit ?? ""
      }`;

  const weightString = hasNoWeight
    ? "No weight data"
    : `${itemDimension.weight ?? "?"} ${itemDimension.weightUnit ?? ""}`;

  return `${sizeString}; ${weightString}`;
}
